import { Brick } from "../../codebricks-runtime/CBModels";
import { CodeBrick } from "../../codebricks-runtime/CodeBrick";

export class CBWebUtil {
    static UnFocus() {
        document.body.click();
        document.querySelector('[tabindex]').focus();
    }

    static focusNextElement( reverse, activeElem ) {
        /*check if an element is defined or use activeElement*/
        activeElem = activeElem instanceof HTMLElement ? activeElem : document.activeElement;
      
        let queryString = [
            'a:not([disabled]):not([tabindex="-1"])',
            'button:not([disabled]):not([tabindex="-1"])',
            'input:not([disabled]):not([tabindex="-1"])',
            'select:not([disabled]):not([tabindex="-1"])',
            '[tabindex]:not([disabled]):not([tabindex="-1"])'
            /* add custom queries here */
          ].join(','),
          queryResult = Array.prototype.filter.call(document.querySelectorAll(queryString), elem => {
            /*check for visibility while always include the current activeElement*/
            return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem === activeElem;
          }),
          indexedList = queryResult.slice().filter(elem => {
            /* filter out all indexes not greater than 0 */
            return elem.tabIndex == -1 ? false : true;
          }).sort((a, b) => {
            /* sort the array by index from smallest to largest */
            return a.tabIndex != 0 && b.tabIndex != 0 
              ? (a.tabIndex < b.tabIndex ? -1 : b.tabIndex < a.tabIndex ? 1 : 0) 
              : a.tabIndex != 0 ? -1 : b.tabIndex != 0 ? 1 : 0;
          }),
          focusable = [].concat(indexedList, queryResult.filter(elem => {
            /* filter out all indexes above 0 */
            return elem.tabIndex == -1 ? true : false;
          }));
      
        /* if reverse is true return the previous focusable element
           if reverse is false return the next focusable element */
        return reverse ? (focusable[focusable.indexOf(activeElem) - 1] || focusable[focusable.length - 1]) 
          : (focusable[focusable.indexOf(activeElem) + 1] || focusable[0]);
    }


    static escapeHtml(unsafe: string)
    {
      if(unsafe && typeof unsafe == "string") {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
      }
      return unsafe;
    }

    static unescapeHtml(unsafe: string)
    {
      if(unsafe && typeof unsafe == "string") {
        return unsafe
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'");
      }
      return unsafe;
    }

    static BrickHtml(blueprint: Brick, container_brick: CodeBrick, idx: number, dc = "", classes = "") {
      let prefix = blueprint.type.split('-')[0];
      if(prefix.indexOf('i') != -1 || prefix[0] == 's') {
        classes += " child-hidden";
      }
      let attrs = "";
      if((<any>window).codebricks_context.visual_editing) {
        attrs = ` class="${classes}" editor-info="${blueprint.name} (${blueprint.type})"`;

        let brick_name = blueprint.name;
        let brick_type = blueprint.type;
        setTimeout(function() { (<any>window).codebricks_context.visual_brick_endow(brick_name, brick_type, true); }, 0);
      }
      else {
        attrs = ` ${classes ? ` class="${classes}"`:""}`;
      }
      let use_dc = dc || container_brick.dc || '';
      let brick = `<${blueprint.type}${attrs} cid="${container_brick.cid}" dc="${use_dc}" name="${blueprint.name}" idx="${idx}" container_id="${container_brick.brick_id}"></${blueprint.type}>`;
      return brick;
    }

    static async PostRequest(url: string, post_body: any) {
      let res_data: any;

        let method = "POST";

        let options = { method };
      
        (<any>options).body = JSON.stringify(post_body);
        
        (<any>options).credentials = 'include';

        (<any>options).headers = { "Content-Type":"application/json"};

        //console.log("web_sc_use "+this.brick_id+" post_body "+JSON.stringify(post_body));

        let res = await fetch(url, options);

        let body = await res.text();
        if(body === "") {
            return; //We do not emit an empty resonse. This gives the server side a way no not emit. Used for request sequencing #rr
        }

        //console.log("web_sc_use "+this.brick_id+" response body "+body);

        try {
            res_data = JSON.parse(body);
        }
        catch(err) {
            res_data = body;
        }
        return res_data;
    }

    static async GetRequest(url: string) {
      let res_data: any;

        let method = "GET";

        let options = { method };
      
        (<any>options).credentials = 'include';

        (<any>options).headers = { "Content-Type":"application/json"};

        //console.log("web_sc_use "+this.brick_id+" post_body "+JSON.stringify(post_body));

        let res = await fetch(url, options);

        let body = await res.text();
        if(body === "") {
            return; //We do not emit an empty resonse. This gives the server side a way no not emit. Used for request sequencing #rr
        }

        //console.log("web_sc_use "+this.brick_id+" response body "+body);

        try {
            res_data = JSON.parse(body);
        }
        catch(err) {
            res_data = body;
        }
        return res_data;
    }
}